<app-navbar [title]="pageTitle">
	<button class="btn btn-primary me-3" (click)="checkAndSubmit()">Zapisz i wyjdź</button>
	<a class="btn btn-danger" routerLink="../"> <i class="fas fa-chevron-left"></i> Powrót </a>
</app-navbar>
<div class="container my-4">
	<form (submit)="submit()">
		<fieldset>
			<div class="form-floating mb-3">
				<input
					type="text"
					id="name"
					class="form-control"
					name="name"
					[(ngModel)]="data.name"
					[disabled]="!editable"
					required
				/>
				<label for="name" class="form-label">Nazwa<small class="ms-2 text-danger">* wymagane</small></label>
			</div>
			<div class="d-flex justify-content-between w-100">
				<div class="form-floating me-2 w-50">
					<input
						type="text"
						id="code"
						class="form-control"
						name="code"
						[(ngModel)]="data.code"
						[disabled]="!editable"
						(ngModelChange)="data.code = $event.toUpperCase()"
						required
					/>
					<label for="currency" class="form-label"
						>Kod<small class="ms-2 text-danger">* wymagane</small></label
					>
				</div>
				<div class="form-floating ms-2 w-50">
					<input
						type="number"
						id="currency"
						class="form-control"
						name="currency"
						[(ngModel)]="data.exchangeRatePln"
						(change)="changeDecimal()"
						required
					/>
					<label for="currency" class="form-label"
						>Kurs<small class="ms-2 text-danger">* wymagane</small></label
					>
				</div>
			</div>
		</fieldset>
	</form>
</div>
